// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-KeydownSubmitForm-KeydownSubmitForm-module__formBox--yYwYh {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/KeydownSubmitForm/KeydownSubmitForm.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".formBox {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `src-components-KeydownSubmitForm-KeydownSubmitForm-module__formBox--yYwYh`
};
export default ___CSS_LOADER_EXPORT___;
